import { Grid } from "@material-ui/core";
import { Card, Statistic } from "antd";
import React from "react";

function index() {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
         <Grid key={index} item>
            <Card
              style={{
                background: "#dd4b39",
                fontSize: 25,
                color: "White",
              }}
              title={<span> Test</span>}
              bordered={true}
            >
              <Statistic value={10} />
            </Card>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
         <Grid key={index} item>
            <Card
              style={{
                background: "#0073b7",
                fontSize: 25,
                color: "white",
              }}
              title={<span> Test</span>}
              bordered={true}
            >
              <Statistic value={10} />
            </Card>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
         <Grid key={index} item>
            <Card
              style={{
                background: "#00a65a",
                fontSize: 25,
                color: "white",
              }}
              title={<span> Test</span>}
              bordered={true}
            >
              <Statistic value={10} />
            </Card>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
         <Grid key={index} item>
            <Card
              style={{
                background: "#00c0ef",
                fontSize: 25,
                color: "white",
              }}
              title={<span> Test</span>}
              bordered={true}
            >
              <Statistic value={10} />
            </Card>
          </Grid>
        </Grid>
      
       </Grid>
    </div>
  );
}

export default index;
